import { render, staticRenderFns } from "./FormBranchComponent.vue?vue&type=template&id=64d4552b&scoped=true"
import script from "./FormBranchComponent.vue?vue&type=script&lang=js"
export * from "./FormBranchComponent.vue?vue&type=script&lang=js"
import style0 from "./FormBranchComponent.vue?vue&type=style&index=0&id=64d4552b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d4552b",
  null
  
)

export default component.exports